import { connect } from 'react-redux';
import { translate } from 'jitsi/base/i18n/functions';
import { toggleLobbyMode } from 'jitsi/lobby/actions.web';
import { updateRoomConfig } from 'common/helpers/api';
import { LobbySection, mapStateToProps } from 'jitsi/lobby/components/web/LobbySection';
/**
 * Implements a security feature section to control lobby mode.
 */
export class IISightLobbySection extends LobbySection {
    /**
     * Callback to be invoked when the user toggles the lobby feature on or off.
     *
     * @returns {void}
     */
    async _onToggleLobby() {
        const newValue = !this.state.lobbyEnabled;
        await updateRoomConfig(newValue ? 'enabled' : 'disabled');
        this.setState({
            lobbyEnabled: newValue,
        });
        this.props.dispatch(toggleLobbyMode(newValue));
    }
}
export default translate(connect(mapStateToProps)(IISightLobbySection));
